// extracted by mini-css-extract-plugin
export default {"productGrid":"V0-z","centerLink":"W0-z","productSection":"X0-z","item":"Y0-z","ctaButton":"Z0-z"};